import { fetch as fetchPolyfill } from 'whatwg-fetch';
import { selectSession } from './reducers/session';
import { updateSessionActions } from './actions/session';

const mutableReferences = {
  store: null,
};

const configureSessionService = store => {
  mutableReferences.store = store;
};

const handleOnline = () => {
  const { store } = mutableReferences;
  if (store && store.dispatch && !selectSession.online(store.getState())) {
    store.dispatch(updateSessionActions.online());
  }
};

const handleOffline = () => {
  const { store } = mutableReferences;
  if (store && store.dispatch && selectSession.online(store.getState())) {
    store.dispatch(updateSessionActions.offline());
  }
};

// Optional chaining is for react-native to simply ignore it.
if (window.addEventListener) {
  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);
}

setInterval(() => {
  const { store } = mutableReferences;
  if (store) {
    if (!selectSession.online(store.getState())) {
      fetchPolyfill(`${process.env.REACT_APP_API_URL || ''}heartbeat/`)
        .then(() => {
          handleOnline();
        })
        .catch(() => {
          console.log('still offline');
          handleOffline();
        });
    }
  }
}, 5000);

export { configureSessionService, handleOnline, handleOffline };
